import { ListBox, ListBoxDragEvent, ListBoxToolbar, processListBoxData, processListBoxDragAndDrop } from '@progress/kendo-react-listbox';
import React, { useEffect, useMemo, useState } from 'react';
import { UserApi } from '../../../../../../redux/api/UserApi';
import { TicketApi } from '../../../../../../redux/api/TicketApi';
import { ComboBox, DropDownList } from '@progress/kendo-react-dropdowns';
import { TextBox } from '@progress/kendo-react-inputs';
import { IStaff } from '../../../../../../types/IStaff';
import { Icon } from '@progress/kendo-react-common';
import { Avatar } from '@progress/kendo-react-layout';
import { ITeam } from '../../../../../../types/ITeam';
import { PartialSpinny } from '../../../../../Nav/Spinny';
import { Setting } from '../../../../../../types/Setting/Setting';
import products from './TestProducts';

interface EditAssignmentProps {
    ticketId?: number;
    newAssignees?: string;
    onChange: (newAssignees: number[]) => void;
}

const renderItem = (props) => {
    let { dataItem, selected, ...others } = props;
    var customElement = <div className='k-hbox' title={dataItem.Full_Name}>
        {dataItem.Show_Profile_Image ? <>
            <Avatar size='medium' rounded='full' className='user-profile-image ' >
                {dataItem.Profile_Image_Path?.indexOf('/images') === 0 ? <img src={`.${dataItem.Profile_Image_Path}`} alt="Profile" width="25" height="25" /> : (dataItem.Profile_Image_Path ? <img src={dataItem.Profile_Image_Path} alt="Profile" width="40" height="40" /> : <img src={'./images/placeholder.png'} alt="Profile" width="40" height="40" />)}
            </Avatar>
            <div className='ms-2'>
                <div className='name'>{dataItem.Full_Name}</div>
                <div className='text-muted'>{dataItem.Team_Name}</div>
            </div></>
            : <div>
                <div className='name'>{dataItem.Full_Name}</div>
                <div className='text-muted'>{dataItem.Team_Name}</div>
            </div>}
    </div>

    return (
        <li {...others}>
            {customElement}
        </li>
    );
};

const EditAssignment: React.FC<EditAssignmentProps> = ({ ticketId, newAssignees, onChange }) => {
    const { data: userProfile } = UserApi.useGetUserProfileQuery();
    const SELECTED_FIELD = 'selected';
    const [newAssignee, setNewAssignee] = useState();
    const { data: ticket } = TicketApi.useGetTicketQuery({ ticketId: ticketId });

    const { data: teams } = UserApi.useGetTeamsQuery();
    const { data: yourTeamSetting } = UserApi.useGetSettingQuery(Setting.YOUR_TEAM_DEFAULT);
    const [filter, setFilter] = useState<string>('');
    const [team, setTeam] = useState<ITeam>(null);
    const { data: staffAndQueues, isLoading } = UserApi.useGetStaffQuery({ teamId: null, includeQueues: true, includeStaffPlusForCompanyId: ticket?.Company_Id }, { skip: !ticket?.Company_Id });
    const queues = staffAndQueues?.filter((s) => s.Is_Queue && (!team || !s.Team_Name || s.Team_Name === team?.Dept_Name))?.map(s => {
        return { ID: s.ID, Full_Name: s.Full_Name, Team_Name: s.Team_Name, [SELECTED_FIELD]: false, Is_Queue: true, Show_Profile_Image: userProfile?.Features.Profile_Images }
    }) || [];
    const staff = staffAndQueues?.filter((s) => !s.Is_Queue && (!team || s.Team_Name === team?.Dept_Name) && (!filter || s.Full_Name?.toLowerCase().includes(filter?.toLowerCase())))?.map(s => {
        return { ID: s.ID, Full_Name: s.Full_Name, Team_Name: s.Team_Name, [SELECTED_FIELD]: false, Is_Queue: false, Profile_Image_Path: s.Profile_Image_Path, Show_Profile_Image: userProfile?.Features.Profile_Images }
    });


    const [draggedItem, setDragItem] = useState({});
    const [state, setState] = React.useState({
        assigned: null,
        staff: null,
        queues: null,
    });

    const assignedIds = state?.assigned?.map(ca => ca.ID) || [];
    const bindStaff = state?.staff?.filter(s => assignedIds.indexOf(s.ID) === -1) || [];
    const bindQueues = state?.queues?.filter(s => assignedIds.indexOf(s.ID) === -1) || [];

    //Log whenever bindStaff changes
    useEffect(() => {
        console.log('bindQueues changed');
    }, [bindQueues]);

    //Default to the current user's team
    useEffect(() => {
        if (yourTeamSetting?.Bool_Value && teams && userProfile) {
            console.log('Setting team', teams.find(t => t.ID === userProfile?.Team_Id));
            setTeam(teams.find(t => t.ID === userProfile?.Team_Id))
        }
    }, [yourTeamSetting, teams, userProfile]);


    useEffect(() => {
        //console.warn('useEffect filter or team')
        if (staff) {
            setState((s) => {
                return { ...s, staff: [...staff] }
            })
        }
        if (queues) {
            setState((s) => {
                return { ...s, queues: [...queues] }
            })
        }
    }, [filter, team]);

    useEffect(() => {
        //console.warn('useEffect staff or ticket', staff?.length)
        if (state.assigned === null && ticket?.Call_Assignment && staff && queues) {
            const assignedStaff = ticket?.Call_Assignment.map(ca => {
                return { ID: ca.Contact_Id, Full_Name: ca.Contact_Name, [SELECTED_FIELD]: false, Is_Queue: ca.Access_Level_Id === 6, Profile_Image_Path: ca.Profile_Image_Path, Team_Name: ca.Team_Name, Show_Profile_Image: userProfile?.Features.Profile_Images }
            });
            //console.warn('Setting initial state', staff?.length);
            setState((s) => {
                return { ...s, assigned: assignedStaff, staff: [...staff], queues: [...queues] }
            })
        }
        // if (state.staff === null && staffAndQueues)
        //     setState((s) => {
        //         return { ...s, staff: staffAndQueues }
        //     })

    }, [staff, ticket]);

    const handleDragStart = (e: ListBoxDragEvent) => {
        setDragItem(e.dataItem);
    };

    const assignDropped = (e: ListBoxDragEvent) => {
        const itemDropped = e.dataItem as IStaff;
        const dragItem = draggedItem as IStaff;

        let result = dragItem.Is_Queue ?
            processListBoxDragAndDrop(
                state.assigned,
                state.queues,
                draggedItem,
                itemDropped,
                'ID'
            ) :
            processListBoxDragAndDrop(
                state.assigned,
                state.staff,
                draggedItem,
                itemDropped,
                'ID'
            );

        console.log('dragItem', dragItem, 'itemDropped:', itemDropped, result)

        dragItem.Is_Queue ?
            setState((s) => {
                return {
                    ...s,
                    assigned: result.listBoxOneData,
                    queues: result.listBoxTwoData
                }
            }) :
            setState((s) => {
                return {
                    ...state,
                    assigned: result.listBoxOneData,
                    staff: result.listBoxTwoData
                }
            });

        onChange(result.listBoxOneData.map(a => a.ID))

    }

    const groupDropped = (e: ListBoxDragEvent) => {
        console.log('assignDropped', e.dataItem)

    }

    const MyCustomItem = props => {
        let { dataItem, selected, ...others } = props;

        return <li {...others} key={dataItem.ID}>
            {props.dataItem.Full_Name}
        </li>;
    };


    const handleToolBarClick = e => {
        console.log('handleToolBarClick', e);
        let toolName = e.toolName || '';
        let result = processListBoxData(state.assigned,
            state.staff, toolName, SELECTED_FIELD);

        setState((s) => {
            return {
                ...s,
                assigned: result.listBoxOneData,
                staff: result.listBoxTwoData
            }
        });

        onChange(result.listBoxOneData.map(a => a.ID))
    };

    const handleQueueToolBarClick = e => {
        console.log('handleToolBarClick', e);
        let toolName = e.toolName || '';
        let result = processListBoxData(state.assigned,
            state.queues, toolName, SELECTED_FIELD);

        setState((s) => {
            return {
                ...s,
                assigned: result.listBoxOneData,
                queues: result.listBoxTwoData
            }
        });

        onChange(result.listBoxOneData.map(a => a.ID))
    };


    const handleItemClick = (event, data, connectedData) => {
        //console.log('handleItemClick', event.dataItem.name, event.dataItem);

        setState(s => {
            return {
                ...s,
                [data]: s[data].map(item => {
                    if (item.ID === event.dataItem.ID) {
                        item[SELECTED_FIELD] = !item[SELECTED_FIELD];
                    } else if (!event.nativeEvent.ctrlKey) {
                        item[SELECTED_FIELD] = false;
                    }
                    return item;
                }),
                [connectedData]: state[connectedData].map(item => {
                    item[SELECTED_FIELD] = false;
                    return item;
                })
            }
        });
    };

    //return <TestApp />;

    return (
        <>
            {/* <TestApp /> */}
            {isLoading && <PartialSpinny />}
            {/* state?.staff = {JSON.stringify(state?.staff?.length)} */}
            <div className='d-flex flex-row-reverse'>
                <div className='col-12 col-lg-8 m-2'>
                    <div className='team-list'><ComboBox filterable={false} allowCustom={false} placeholder={`Filter by ${userProfile?.Phrases.Team}`} data={teams} value={team} textField='Dept_Name' onChange={(e) => setTeam(e.value)} /></div>
                </div>
            </div>
            <div className='row align-top'>
                <div className='col-6 col-lg-4'>
                    <h6>
                        Assigned: ({state.assigned?.length})
                        {/* team:{JSON.stringify(team)} */}
                    </h6>
                    <ListBox onDragStart={handleDragStart} item={renderItem} selectedField={SELECTED_FIELD} onItemClick={e => handleItemClick(e, 'assigned', 'staff')}
                        className='assigned-list' data={state.assigned || []} textField='Full_Name' key='ID' onDrop={assignDropped} />
                </div>
                <div className='col-6 col-lg-8 ps-0'>
                    <div className='col-lg-6 col-12 d-inline-block'>
                        <h6 className='staff-header'>
                            Staff:
                        </h6>
                        <div>
                            <div className='search-wrapper'><TextBox prefix={() => <><Icon className='m-2' name='search'></Icon></>} className='' placeholder='Search...' value={filter} onChange={(e) => setFilter(e.value.toString())} /></div>
                            <ListBox
                                selectedField={SELECTED_FIELD}
                                onItemClick={e => handleItemClick(e, 'staff', 'assigned')}
                                onDragStart={handleDragStart} item={renderItem}
                                toolbarPosition='left' //item={MyCustomItem}
                                toolbar={() => {
                                    return (
                                        <ListBoxToolbar
                                            tools={[
                                                'transferFrom',
                                                'transferTo'
                                            ]}
                                            data={state.assigned || []}
                                            dataConnected={state?.staff || []}
                                            onToolClick={handleToolBarClick}
                                        />
                                    );
                                }}
                                className='staff-list' data={state?.staff || []} textField='Full_Name' valueField='ID' onDrop={assignDropped} />
                        </div>
                    </div>
                    <div className='col-lg-6 col-12 d-inline-block align-top ps-2'>
                        <h6 className='staff-header'>
                            Groups:
                        </h6>
                        <ListBox selectedField={SELECTED_FIELD} onItemClick={e => handleItemClick(e, 'queues', 'assigned')}
                            onDragStart={handleDragStart} className='queue-list' data={queues || []} textField='Full_Name' valueField='ID' onDrop={assignDropped}
                            toolbarPosition='left' item={MyCustomItem}
                            toolbar={() => {
                                return (
                                    <ListBoxToolbar
                                        tools={[
                                            'transferFrom',
                                            'transferTo'
                                        ]}
                                        data={state.assigned || []}
                                        dataConnected={bindQueues || []}
                                        onToolClick={handleQueueToolBarClick}
                                    />
                                );
                            }} />
                    </div>
                </div>
            </div>
        </>
    );
};

export default EditAssignment;


const parsedProducts = products.map(product => {
    product.selected = false;
    return product;
});
const MyCustomItem = props => {
    let {
        dataItem,
        selected,
        ...others
    } = props;
    //console.log('MyCustomItem!', props.dataItem.ID, props.key, props);
    return <li {...others}>
        <div>
            <span style={{
                fontWeight: 'bold'
            }}>{props.dataItem.Full_Name}</span>
            <br />
            <span>{props.dataItem.Team_Name}</span>
        </div>
    </li>;
};

const SELECTED_FIELD = 'selected';
export const TestApp = () => {
    const { data: userProfile } = UserApi.useGetUserProfileQuery();
    const [filter, setFilter] = useState<string>('');
    const [team, setTeam] = useState<ITeam>(null);
    const { data: staffAndQueues, isLoading } = UserApi.useGetStaffQuery({ teamId: null, includeQueues: true, includeStaffPlusForCompanyId: 0 });
    const queues = staffAndQueues?.filter((s) => s.Is_Queue && (!team || !s.Team_Name || s.Team_Name === team?.Dept_Name))?.map(s => {
        return { ID: s.ID, Full_Name: s.Full_Name, Team_Name: s.Team_Name, [SELECTED_FIELD]: false, Is_Queue: true }
    }) || [];
    const staff = staffAndQueues?.filter((s) => !s.Is_Queue && (!team || s.Team_Name === team?.Dept_Name) && (!filter || s.Full_Name?.toLowerCase().includes(filter?.toLowerCase())))?.map(s => {
        return { ID: s.ID, Full_Name: s.Full_Name, Team_Name: s.Team_Name, [SELECTED_FIELD]: false, Is_Queue: false, Profile_Image_Path: s.Profile_Image_Path }
    });

    useEffect(() => {
        console.warn('useEffect filter or team')
        if (staff && !state.notDiscontinued?.length) {
            setState((s) => {
                return { ...s, notDiscontinued: [...staff] }
            })
        }
        if (queues && !state.discontinued?.length) {
            setState((s) => {
                return { ...s, discontinued: [...queues] }
            })
        }
    }, [staff, queues]);


    const [state, setState] = React.useState({
        notDiscontinued: [],
        discontinued: [],
        draggedItem: {}
    });
    const handleItemClick = (event, data, connectedData) => {
        setState({
            ...state,
            [data]: state[data].map(item => {
                if (item.ID === event.dataItem.ID) {
                    item[SELECTED_FIELD] = !item[SELECTED_FIELD];
                } else if (!event.nativeEvent.ctrlKey) {
                    item[SELECTED_FIELD] = false;
                }
                return item;
            }),
            [connectedData]: state[connectedData].map(item => {
                item[SELECTED_FIELD] = false;
                return item;
            })
        });
    };
    const handleToolBarClick = e => {
        let toolName = e.toolName || '';
        let result = processListBoxData(state.notDiscontinued, state.discontinued, toolName, SELECTED_FIELD);
        setState({
            ...state,
            notDiscontinued: result.listBoxOneData,
            discontinued: result.listBoxTwoData
        });
    };
    const handleDragStart = e => {
        setState({
            ...state,
            draggedItem: e.dataItem
        });
    };
    const handleDrop = e => {
        let result = processListBoxDragAndDrop(state.notDiscontinued, state.discontinued, state.draggedItem, e.dataItem, 'ProductID');
        setState({
            ...state,
            notDiscontinued: result.listBoxOneData,
            discontinued: result.listBoxTwoData
        });
    };
    return <div className="container">
        <div className="row justify-content-center">
            <div className="col">
                <h6>Not Discontinued</h6>
                <ListBox textField="Full_Name" style={{
                    height: 350,
                    width: '100%'
                }} data={state?.notDiscontinued || []} selectedField={SELECTED_FIELD} onItemClick={e => handleItemClick(e, 'notDiscontinued', 'discontinued')} onDragStart={handleDragStart} onDrop={handleDrop} item={renderItem} toolbar={() => {
                    return <ListBoxToolbar tools={['moveUp', 'moveDown', 'transferTo', 'transferFrom', 'transferAllTo', 'transferAllFrom', 'remove']} data={state?.notDiscontinued} dataConnected={state?.discontinued} onToolClick={handleToolBarClick} />;
                }} />
            </div>
            <div className="col">
                <h6>Discontinued</h6>
                <ListBox textField="Full_Name" style={{
                    height: 350,
                    width: '100%'
                }} data={state.discontinued} selectedField={SELECTED_FIELD} onItemClick={e => handleItemClick(e, 'discontinued', 'notDiscontinued')} onDragStart={handleDragStart} onDrop={handleDrop} item={MyCustomItem} />
            </div>
        </div>
    </div>;
};
